import { render, staticRenderFns } from "./history-detail-drawer.vue?vue&type=template&id=5b04f6db&scoped=true&"
import script from "./history-detail-drawer.vue?vue&type=script&lang=js&"
export * from "./history-detail-drawer.vue?vue&type=script&lang=js&"
import style0 from "./history-detail-drawer.vue?vue&type=style&index=0&id=5b04f6db&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b04f6db",
  null
  
)

export default component.exports